<form [name]="'alertCredits' + alertNr" [id]="'alertCredits' + alertNr" [formGroup]="alert">
  <div>
    <div class="alert-credit">
      <mat-slide-toggle
        aria-label="Slide me!"
        class="alert-credit__toggle"
        data-label-on="On"
        data-label-off="Off"
        formControlName="enabled"
      >
      </mat-slide-toggle>
      <div class="alert-credit__content">
        <div class="page__form-wrap">
          <div class="form-group">
            <div class="row">
              <label [for]="'notify-by-sms' + alertNr" class="col-sm-4" translate>settings_alert_mode_sms</label>
              <div class="col-sm-8  d-inline-flex  align-items-center">
                <wsb-ui-checkbox
                  [checked]="alert.get('notifyBySms').value"
                  [checkboxId]="'notify-by-sms-checkbox' + alertNr"
                  class="me-3"
                  formControlName="notifyBySms"
                  (checkedChange)="validateForm('notificationMobileNumber')"
                ></wsb-ui-checkbox>
                <!--              <input type="tel" name="notificationMobileNumber" class="form-control" id="notify-by-sms" formControlName="notificationMobileNumber" wsbAppControlValidator [fc]="alert.get('notificationMobileNumber')"/>-->
                <wsb-atlas-inputphone
                  [name]="'notificationMobileNumber' + alertNr"
                  [id]="'notify-by-sms' + alertNr"
                  [cssClass]="'form-control'"
                  [readonly]="!alert.get('notifyBySms').value"
                  [formControlName]="'notificationMobileNumber'"
                  wsbAppControlValidator
                  [fc]="inputPhone.phoneNumber"
                  #inputPhone
                ></wsb-atlas-inputphone>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7 offset-sm-5">
                <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label [for]="'notify-by-email' + alertNr" class="col-sm-4" translate>settings_alert_mode_email</label>
              <div class="col-sm-8  d-inline-flex  align-items-center">
                <wsb-ui-checkbox
                  [checked]="alert.get('notifyByEmail').value"
                  [checkboxId]="'notify-by-email-checkbox' + alertNr"
                  class="me-3"
                  formControlName="notifyByEmail"
                  (checkedChange)="validateForm('notificationEmail')"
                ></wsb-ui-checkbox>
                <input
                  type="email"
                  [name]="'notificationEmail' + alertNr"
                  class="form-control"
                  [readonly]="!alert.get('notifyByEmail').value"
                  [id]="'notify-by-email' + alertNr"
                  formControlName="notificationEmail"
                  wsbAppControlValidator
                  [fc]="alert.get('notificationEmail')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7 offset-sm-5">
                <wsb-validation-error-msg [fc]="alert.get('notificationEmail')"></wsb-validation-error-msg>
              </div>
            </div>
          </div>

          <div class="form-group align-items-center" *ngIf="typologieCurrencyAlerteCredit">
            <div class="row">
              <label [for]="'notify-by-email' + alertNr" class="col-sm-4" translate>settings_alert_threshold_unit</label>
              <div class="col-sm-8 d-inline-flex align-items-center">
                <div class="form-check-inline" wsbAppControlValidator [fc]="alert.get('creditType')">
                  <label class="radio-custom">
                    <input type="radio" formControlName="creditType" [value]="'sms'" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_sms</span>
                  </label>
                  <label class="radio-custom">
                    <input type="radio" formControlName="creditType" [value]="'eur'" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_currency</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8 offset-sm-4">
                <wsb-validation-error-msg [fc]="alert.get('creditType')"></wsb-validation-error-msg>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label class="col-sm-4" translate>settings_alert_threshold_limit</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  formControlName="alertLimit"
                  wsbAppControlValidator
                  [fc]="alert.get('alertLimit')"
                  class="form-control  form-control--short  text-end"
                />
              </div>
            </div>
            <div class="col-sm-8 offset-sm-4">
              <wsb-validation-error-msg [fc]="alert.get('alertLimit')"></wsb-validation-error-msg>
            </div>
          </div>
          <wsb-ui-radio-credit-types
            [creditType]="alert.get('smsType').value"
            [hidden]="!hasMoreThanOneCreditType"
            class="form-group row  align-items-start"
            formControlName="smsType"
            wsbAppControlValidator
            [fc]="alert.get('smsType')"
            (creditTypesChange)="onCreditTypes($event)"
          ></wsb-ui-radio-credit-types>
          <div *ngIf="hasMoreThanOneCreditType" class="col-sm-8 offset-sm-4">
            <wsb-validation-error-msg [fc]="alert.get('smsType')"></wsb-validation-error-msg>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
